import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=008b55ec&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"
import style0 from "./EventView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EventView.vue?vue&type=style&index=1&id=008b55ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008b55ec",
  null
  
)

export default component.exports